import React, { useEffect, useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { format, parseISO } from 'date-fns';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, TextField } from '@mui/material';
import { MdDelete } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import Modal from 'react-bootstrap/Modal';
import { Player, Controls } from '@lottiefiles/react-lottie-player';
import { FiAlertTriangle } from "react-icons/fi";

export default function ExeMember() {

    const lottiee = require('../images/lottiee.json');
    const loading = require('../images/loading.json');

    const [show, setShow] = useState(false);
    const [smShow, setSmShow] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [show2, setShow2] = useState(false);

    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);

    const [membrData, setmembrData] = useState([]);
    const [ExecutiveMembers_Name, setExecutiveMembers_Name] = useState('');
    const [ExecutiveMembers_BusinessName, setExecutiveMembers_BusinessName] = useState('');
    const [ExecutiveMembers_Profession, setExecutiveMembers_Profession] = useState('');
    const [updateExeMember, setupdateExeMember] = useState({});
    const [loader, setloader] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");

    const filteredData = membrData.filter((item) => {
        return (
          item.ExecutiveMembers_Name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.ExecutiveMembers_BusinessName.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.ExecutiveMembers_Profession.toLowerCase().includes(searchQuery.toLowerCase())
        );
      });

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(0);
    };

    const exeData = ()=>{
        setloader(true)
        const requestOptions = {
          method: "GET",
          redirect: "follow"
        };
        
        fetch("https://api.padampura.com/Committee_MemberList", requestOptions)
         .then((response) => response.json())
          .then((result) => {
            if(result.status === true){
            //   console.log(result)
              setmembrData(result.data.ExecutiveMembers)
              setloader(false)
            }
          })
          .catch((error) => console.error(error))
          .finally(()=> setloader(false))
      }

      const insertExeMbr = ()=>{
        if (!ExecutiveMembers_Name) {
            alert("Please enter Name");
            return;
        }
        const myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                "ExecutiveMembers_Name": ExecutiveMembers_Name,
                "ExecutiveMembers_BusinessName": ExecutiveMembers_BusinessName,
                "ExecutiveMembers_Profession": ExecutiveMembers_Profession,
                // "ExecutiveMembers_ImagePath": ""
            });

            const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
            };

            fetch("https://api.padampura.com/Committee_Member_Insert", requestOptions)
            .then((response) => response.json())
             .then((result) => {
                 if(result.status === true){
                     // console.log(result);
                     alert("Insert Successfully");
                     exeData();
                 }else{
                     alert("Try Again !!");
                 }
             })
             .catch((error) => console.error(error));
      }

      const handleChangeUpdtExeMbr = (e) => {
        const { name, value, type, checked } = e.target;
        setupdateExeMember({
          ...updateExeMember,
          [name]: type === "checkbox" ? checked : value,
        });
      };

      const updateMembr = ()=>{
        const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                ...updateExeMember
            // "ExecutiveMembers_Name": "Test Exe1",
            // "ExecutiveMembers_BusinessName": "Exe Business",
            // "ExecutiveMembers_Profession": "Manufacturing",
            // "ExecutiveMembers_ImagePath": ""
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            fetch(`https://api.padampura.com/Committee_Member_Update?MainID=${updateExeMember.ExecutiveMembers_ID}`, requestOptions)
            .then((response) => response.json())
             .then((result) => {
                 if(result.status === true){
                     // console.log(result)
                     alert("Update Successfully");
                     exeData();
                 }else{
                     alert("Try Again !!")
                 }
             })
             .catch((error) => console.error(error));
      }

      const deleteMember = ()=>{
        const requestOptions = {
            method: "DELETE",
            redirect: "follow"
          };
          
          fetch(`https://api.padampura.com/Committee_Member_Delete?MainID=${updateExeMember.ExecutiveMembers_ID}`, requestOptions)
          .then((response) => response.json())
            .then((result) => {
                if(result.status === true){
                    alert("Delete Successfully");
                    exeData();
                }else{
                    alert("Try Again !!")
                }
            })
            .catch((error) => console.error(error));
      }

      useEffect(()=>{
        exeData();
      },[])

    return (
        <>
            <div className='container-fluid p-0'>
                <div className='row g-0'>
                    <div className='col-2 side'>
                        <Sidebar />
                    </div>
                    <div className='col-10 side2'>
                        <Header />
                        <div className='scroll-box'>
                            <div className="container-fluid">
                                <div className='row d-flex justify-content-between mt-2'>
                                   <div className='col-4' style={{ fontFamily: "Poppins", fontWeight: 600, fontSize: "1.2em", }} >Executive Member</div>
                                     <div className='col-4'>
                                       <TextField
                                           label="Search Members"
                                           value={searchQuery}
                                           onChange={(e) => setSearchQuery(e.target.value)}
                                           variant="outlined"
                                           size="small"
                                           fullWidth
                                           sx={{ mb: 0 }}
                                        />
                                     </div>
                                   <div onClick={handleShow} className='col-2 d-flex justify-content-center align-items-center p-1 rounded-1' style={{ backgroundColor:"#2C3E50", fontFamily:"Poppins", fontWeight:400, color:"#fff", cursor:"pointer" }}>+ Add</div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-12 m-auto">
                                        <div className='card-list-box-sr card p-2 border-0'>
                                            <div className="table-responsive">
                                                <Paper sx={{ width: '100%' }}>
                                                    <TableContainer sx={{ mt: -1 }}>
                                                        <Table stickyHeader aria-label="sticky table" size="small">
                                                            <TableHead className='text-center'>
                                                                <TableRow>
                                                                  <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Name</TableCell>
                                                                  <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Business Name</TableCell>
                                                                  <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Profession</TableCell>
                                                                  <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Action</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {
                                                                    loader?(
                                                                        <TableRow>
                                                                            <TableCell colSpan={4} align="center">
                                                                                <div style={{ fontFamily:"Poppins", fontSize:16 }} >Loading...</div>
                                                                                <Player
                                                                                    autoplay
                                                                                    loop
                                                                                    src={loading}
                                                                                    style={{ height: '200px', width: '200px' }}
                                                                                >
                                                                                <Controls visible={false} buttons={['play', 'repeat', ]} />
                                                                            </Player>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    ):filteredData.length === 0 ? (
                                                                        <TableRow>
                                                                            <TableCell colSpan={4} align="center">
                                                                             <Player
                                                                                    autoplay
                                                                                    loop
                                                                                    src={lottiee}
                                                                                    style={{ height: '100px', width: '100px' }}
                                                                                >
                                                                                <Controls visible={false} buttons={['play', 'repeat', ]} />
                                                                             <div style={{ fontFamily:"Poppins", fontSize:16, color:'red' }} >Data Not Present...</div>
                                                                             </Player>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )
                                                                    :(
                                                                        filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => (
                                                                            <TableRow className='text-center'>
                                                                                <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}>{item.ExecutiveMembers_Name}</TableCell>
                                                                                <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}>{item.ExecutiveMembers_BusinessName}</TableCell>
                                                                                <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}>{item.ExecutiveMembers_Profession}</TableCell>
                                                                                <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", }}>
                                                                                   <div className='d-flex justify-content-between' style={{ width:50 }}>
                                                                                     <FaEdit onClick={() => { handleShow2();setupdateExeMember({...item})}} style={{ cursor: "pointer", color:"#566573" }} />
                                                                                     <MdDelete onClick={()=> {setSmShow(true);setupdateExeMember({...item})}} style={{ cursor: "pointer", color: "#E74C3C" }} />
                                                                                   </div>
                                                                                </TableCell>
                                                                             </TableRow>
                                                                            ))
                                                                    )
                                                                }
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                    <TablePagination
                                                        rowsPerPageOptions={[5, 10, 20]}
                                                        component="div"
                                                        count={membrData.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onPageChange={handleChangePage}
                                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                                    />
                                                </Paper>
                                                <Modal show={show} onHide={handleClose} size="lg" aria-labelledby="example-modal-sizes-title-lg">
                                                   <Modal.Header closeButton>
                                                      <Modal.Title>Add Executive Member</Modal.Title>
                                                   </Modal.Header>
                                                   <Modal.Body>
                                                      <div className='container-fluid'>
                                                          <div className='row'>
                                                          <div className='col-lg-4 col-md-6 col-sm-12'>
                                                              <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Name</div>
                                                              <input className='sercc-inpt p-1' value={ExecutiveMembers_Name} onChange={(e)=> setExecutiveMembers_Name(e.target.value)} placeholder="Name" autoFocus required style={{width:"100%"}} />
                                                          </div>
                                                          <div className='col-lg-4 col-md-6 col-sm-12'>
                                                              <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Business Name</div>
                                                              <input className='sercc-inpt p-1' value={ExecutiveMembers_BusinessName} onChange={(e)=> setExecutiveMembers_BusinessName(e.target.value)} placeholder="Business Name" autoFocus required style={{width:"100%"}} />
                                                          </div>
                                                          <div className='col-lg-4 col-md-6 col-sm-12'>
                                                              <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Profession</div>
                                                              <input className='sercc-inpt p-1' value={ExecutiveMembers_Profession} onChange={(e)=> setExecutiveMembers_Profession(e.target.value)} placeholder="Profession" autoFocus required style={{width:"100%"}} />
                                                          </div>
                                                          </div>
                                                          <div className='row mt-2'>
                                                            <div className='col-2 m-auto'>
                                                              <div onClick={()=> {insertExeMbr();handleClose();setExecutiveMembers_Name('');setExecutiveMembers_BusinessName('');setExecutiveMembers_Profession('')}} className='d-flex justify-content-center align-items-center p-1 rounded-1' style={{ width:'100%', backgroundColor:"#2C3E50", fontFamily:"Poppins", fontWeight:400, color:"#fff", cursor:"pointer" }}>Save</div>
                                                            </div>
                                                          </div>
                                                      </div>
                                                   </Modal.Body>
                                                </Modal>
                                                <Modal show={show2} onHide={handleClose2} size="lg" aria-labelledby="example-modal-sizes-title-lg">
                                                    <Modal.Header closeButton>
                                                       <Modal.Title>Executive Member</Modal.Title>
                                                    </Modal.Header>
                                                     <Modal.Body>
                                                        <div className='container-fluid'>
                                                            <div className='row'>
                                                             <div className='col-lg-4 col-md-12 col-sm-12'>
                                                                <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Name</div>
                                                                <input className='sercc-inpt p-1' name='ExecutiveMembers_Name' value={updateExeMember.ExecutiveMembers_Name} onChange={handleChangeUpdtExeMbr} placeholder="Name" autoFocus required style={{width:"100%"}} />
                                                             </div>
                                                             <div className='col-lg-4 col-md-12 col-sm-12'>
                                                                <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Business Name</div>
                                                                <input className='sercc-inpt p-1' name='ExecutiveMembers_BusinessName' value={updateExeMember.ExecutiveMembers_BusinessName} onChange={handleChangeUpdtExeMbr} placeholder="Business Name" autoFocus required style={{width:"100%"}} />
                                                             </div>
                                                             <div className='col-lg-4 col-md-12 col-sm-12'>
                                                                <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Profession</div>
                                                                <input className='sercc-inpt p-1' name='ExecutiveMembers_Profession' value={updateExeMember.ExecutiveMembers_Profession} onChange={handleChangeUpdtExeMbr} placeholder="Profession" autoFocus required style={{width:"100%"}} />
                                                             </div>
                                                            </div>
                                                            <div className='row mt-2'>
                                                              <div className='col-2 m-auto'>
                                                                <div onClick={()=> {updateMembr();handleClose2()}} className='d-flex justify-content-center align-items-center p-1 rounded-1' style={{ width:'100%', backgroundColor:"#2C3E50", fontFamily:"Poppins", fontWeight:400, color:"#fff", cursor:"pointer" }}>Update</div>
                                                              </div>
                                                            </div>
                                                        </div>
                                                    </Modal.Body>
                                                </Modal>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                size="sm"
                show={smShow}
                onHide={() => setSmShow(false)}
                aria-labelledby="example-modal-sizes-title-sm"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-sm">
                        <FiAlertTriangle style={{ color: "orangered" }} />
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center align-items-center" style={{ fontFamily: 'Poppins', fontSize: "16px", color: '#1f5156', fontWeight: 500 }}>Are you sure want to Delete ??</div>
                    <div className='d-flex justify-content-between mt-3'>
                        <div onClick={()=> {setSmShow(false);deleteMember()}} className='d-flex justify-content-center align-items-center p-1 rounded-1 me-2' style={{ width: '100%', backgroundColor: "#239B56", fontFamily: "Poppins", fontWeight: 400, color: "#fff", cursor: "pointer" }}>Yes</div>
                        <div onClick={()=> setSmShow(false)} className='d-flex justify-content-center align-items-center p-1 rounded-1' style={{ width: '100%', backgroundColor: "#E74C3C", fontFamily: "Poppins", fontWeight: 400, color: "#fff", cursor: "pointer" }}>No</div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}
